(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.factory('Message', ['HelperService', MessageFn]);

    // extended model for message entity including fields and methods for message-table
    function MessageFn(HelperService) {

        var Message = function () {

            // default values
            this.title = null;
            this.content = null;
            this.contactInfo = null;
            this.contactInfoBCC = null;
            this.costs = null;
            this.duration = null;
            this.virtualNumber = null;
            this.intern = null;
            this.waitTime = null;
            this.messageDate = null;
            this.messageType = 0;
            this.fK_User = null;
            this.userDto = null;
            this.externalId = null;
            this.deleted = false;
            this.callGuid = null;
        };

        // extend object
        Message.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        }; // extend

        // prepare for save
        Message.prototype.prepareForSave = function () {
            var self = this;

            self.fK_User = self.userDto ? self.userDto.id : self.fK_User;

            delete self.userDto;
        };

        return Message;
    }
})();